// extracted by mini-css-extract-plugin
export default {"incorrectBirth":"SignUpIncorrectBirthStep_incorrectBirth__zDM5eLtg","warning":"SignUpIncorrectBirthStep_warning__8BkKbQmy","back":"SignUpIncorrectBirthStep_back__M0yeNrmI"};